var exports = {
  "k": "x112a1f60--d0419e--container",
};

module.exports = exports;
